export function formatNumberLabel (value, type = 'decimal', currency) {
  if (value !== 0 && !value) return 0
  if (type === 'currency') {
    const currencyVal = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency || 'USD'
    }).format(value)
    return (isNaN(parseFloat(currencyVal.slice(1))) ? 0 : currencyVal) || 0
  } else if (type === 'percent') {
    return `${value?.toFixed(2)}%`
  } else {
    return new Intl.NumberFormat('en-US', {
      style: 'decimal',
      maximumFractionDigits: 2
    }).format(value)
  }
}
